// Plausible custom-event tracking.
//
// `usePublicAnalytics` (src/hooks/usePublicAnalytics.ts) injects the self-hosted
// Plausible "new" snippet (pa-*.js) and seeds a `window.plausible` queue stub
// before the external script loads. Custom events fired here are pushed onto
// that queue (`plausible.q`) and flushed automatically once pa-*.js initializes,
// so call ordering relative to script load never matters.
//
// Event names here MUST match the "Custom event" goal names registered in the
// Plausible dashboard verbatim, or conversions won't be counted.

type Props = Record<string, string | number | boolean>;

interface PlausibleFn {
  (name: string, options?: { props?: Props }): void;
}

/**
 * Fire a Plausible custom event. SSR-safe and never throws — analytics must
 * never break a user-facing action (form submit, navigation, etc.).
 */
export function trackEvent(name: string, props?: Props): void {
  if (typeof window === 'undefined') return;
  const plausible = (window as unknown as { plausible?: PlausibleFn }).plausible;
  try {
    plausible?.(name, props ? { props } : undefined);
  } catch {
    /* swallow — tracking is best-effort */
  }
}
